module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.myMessagesInvoke
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.messagesCount))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.messagesCount) + " message(s)")]), _vm._v(" "), _vm._l((_vm.myMessages), function(item) {
    return (_vm.messagesCount > 0) ? _c('li', [_c('ul', {
      staticClass: "menu"
    }, [_c('li', [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.subItemClick(item)
        }
      }
    }, [_c('h4', [_vm._v("\n                          " + _vm._s(item.subject) + "\n                          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.body))])])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.messagesCount > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("See All Messages")])]) : _vm._e()], 2)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.notifications)))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.notifications)) + " notification(s)")]), _vm._v(" "), (_vm.userInfo.notifications.length > 0) ? _c('li', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.notifications.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm._f("count")(_vm.userInfo.tasks)) + " task(s)")]), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.tasks.length > 0) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("View all tasks")])]) : _vm._e()])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": require("../../static/img/avatar5.png"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.username))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": require("../../static/img/avatar5.png"),
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.username) + "\n                  ")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.roles) + "\n                  ")])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("退出")])])])])])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n          " + _vm._s(_vm.$route.name.toUpperCase()) + "\n          "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(5), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "control-sidebar-bg"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo-lg"
  }, [_c('span', [_vm._v("农工商长征医药渠道查询")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-aqua"
  }), _vm._v(" 5 new members joined today\n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('h3', [_vm._v("\n                          Design some buttons\n                          "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% Complete")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "/manage/profile"
    }
  }, [_vm._v("用户信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "control-sidebar control-sidebar-dark"
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-justified control-sidebar-tabs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#control-sidebar-home-tab",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#control-sidebar-settings-tab",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "control-sidebar-home-tab"
    }
  }, [_c('h3', {
    staticClass: "control-sidebar-heading"
  }, [_vm._v("Recent Activity")]), _vm._v(" "), _c('ul', {
    staticClass: "control-sidebar-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "menu-icon fa fa-birthday-cake bg-red"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-info"
  }, [_c('h4', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("Langdon's Birthday")]), _vm._v(" "), _c('p', [_vm._v("Will be 23 on April 24th")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "menu-icon fa fa-user bg-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-info"
  }, [_c('h4', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("Frodo Updated His Profile")]), _vm._v(" "), _c('p', [_vm._v("New phone +1(800)555-1234")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "menu-icon fa fa-envelope-o bg-light-blue"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-info"
  }, [_c('h4', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("Nora Joined Mailing List")]), _vm._v(" "), _c('p', [_vm._v("nora@example.com")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "menu-icon fa fa-file-code-o bg-green"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-info"
  }, [_c('h4', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("Cron Job 254 Executed")]), _vm._v(" "), _c('p', [_vm._v("Execution time 5 seconds")])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "control-sidebar-heading"
  }, [_vm._v("Tasks Progress")]), _vm._v(" "), _c('ul', {
    staticClass: "control-sidebar-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('h4', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                  Custom Template Design\n                  "), _c('span', {
    staticClass: "label label-danger pull-right"
  }, [_vm._v("70%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    staticStyle: {
      "width": "70%"
    }
  })])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('h4', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                  Update Resume\n                  "), _c('span', {
    staticClass: "label label-success pull-right"
  }, [_vm._v("95%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    staticStyle: {
      "width": "95%"
    }
  })])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('h4', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                  Laravel Integration\n                  "), _c('span', {
    staticClass: "label label-warning pull-right"
  }, [_vm._v("50%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-warning",
    staticStyle: {
      "width": "50%"
    }
  })])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('h4', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                  Back End Framework\n                  "), _c('span', {
    staticClass: "label label-primary pull-right"
  }, [_vm._v("68%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xxs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-primary",
    staticStyle: {
      "width": "68%"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "control-sidebar-stats-tab"
    }
  }, [_vm._v("Stats Tab Content")]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "control-sidebar-settings-tab"
    }
  }, [_c('form', {
    attrs: {
      "method": "post"
    }
  }, [_c('h3', {
    staticClass: "control-sidebar-heading"
  }, [_vm._v("General Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                Report panel usage\n                "), _c('input', {
    staticClass: "pull-right",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                Some information about this general settings option\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                Allow mail redirect\n                "), _c('input', {
    staticClass: "pull-right",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                Other sets of options are available\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                Expose author name in posts\n                "), _c('input', {
    staticClass: "pull-right",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                Allow the user to show his name in blog posts\n              ")])]), _vm._v(" "), _c('h3', {
    staticClass: "control-sidebar-heading"
  }, [_vm._v("Chat Settings")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                Show me as online\n                "), _c('input', {
    staticClass: "pull-right",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                Turn off notifications\n                "), _c('input', {
    staticClass: "pull-right",
    attrs: {
      "type": "checkbox"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-sidebar-subheading"
  }, [_vm._v("\n                Delete chat history\n                "), _c('a', {
    staticClass: "text-red pull-right",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e3e5caac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 1765
// module chunks = 2